import PictureText from './pictureText';
export default PictureText;